import React from "react";

import {
    chooseAllSpendCategories,
    deselectAllSpendCategories,
    selectSpendCategories,
    toggleSpendCategoryIsSelected
} from "modules/customer/tools/location/spend/spendSlice";
import { useAppSelector } from "store";
import MultiSelectFilter from "components/filters/MultiSelectFilter";

const MarketCategoriesFilter: React.FC = () => {
    const spendCategories = useAppSelector(selectSpendCategories);
    return (
        <MultiSelectFilter
            title="Market categories"
            chooseAllItems={chooseAllSpendCategories}
            deselectAllItems={deselectAllSpendCategories}
            toggleItemIsSelected={toggleSpendCategoryIsSelected}
            items={spendCategories}
        />
    );
};

export default MarketCategoriesFilter;
